
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/search",
      function () {
        return require("private-next-pages/projects/search/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/search"])
      });
    }
  